import { CalendarOptions } from "fullcalendar"
import { arrToCls } from "./helpers"

export const dowToLang = {
	iw: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
	iwShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
	en: [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday",
	],
}

export const fcCommonOptions: CalendarOptions = {
	initialView: "timeGridWeek",
	slotHeaderFormat: { hour: "2-digit" },
	slotMinTime: "05:00:00",
	slotMaxTime: "00:00:00",
	allDaySlot: false,
	height: "auto",
	timeZone: "UTC",
	eventDisplay: "block",
	headerToolbar: false,
}

export const fcCommonClasses: CalendarOptions = {
	dayLaneClass: (arg: any) =>
		arrToCls(["fb-day-bg", "day-lane", arg.isToday && "today"]),
	slotHeaderInnerClass: "fc-header",
	slotLaneClass: (arg: any) => arrToCls(["slot-lane", !arg.isMinor && "major"]),
	slotHeaderDividerClass: "slot-header-divider",
	dayHeaderDividerClass: "no-bord",
	tableClass: "no-bord",
	eventClass: "event",
	dayHeaderClass: arrToCls([
		"fc-header-height",
		"day-header",
		"fc-header",
		"no-bord",
	]),
	tableHeaderClass: "table-header",
	tableBodyClass: "cal-table-body",
}
